import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import LaunchIcon from "@material-ui/icons/Launch";
import PeopleIcon from "@material-ui/icons/People";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import dayjs from "dayjs";
import useFilter from "Hooks/useFilter";
import { fromMonthly, toMonthly } from "fuction/date";
import replaceTweetText from "fuction/replaceTweetText";
import useAuth from "Hooks/useAuth";

dayjs.locale("ja");

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  inline: {
    display: "inline",
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    listStyle: "none",
    "& > li": {
      marginLeft: 5,
    },
  },
  postDate: {
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 10,
    marginRight: 10,
  },
  text: {
    whiteSpace: "pre-wrap",
  },
  book: {
    position: "absolute",
    right: 15,
    top: 15,
  },
  isPrimaryHideBook: {
    width: '100%',
    textAlign: 'right',
  },
  rtCount: {
    position: "absolute",
    right: 50,
    top: 18,
    color: "#f00",
    fontSize: 16,
  },
  imgList: {
    display: "flex",
    flexWrap: "wrap",
  },
  img: {
    marginRight: "5px",
  }
}));

export default function Tweet({ row, isPrimaryHide, isHideImage, order, retweetCount }) {
  const filter = useFilter();
  const auth = useAuth();
  const classes = useStyles();
  const fromDate = fromMonthly(filter.state.filteredDateFrom);
  const toDate = toMonthly(filter.state.filteredDateTo);
  const activeGroup = auth.state.activeGroup;

  const MyImg = ({ row }) => {
    let entities = [];
    if (row.retweeted_status) {
      if (
        row.retweeted_status.extended_tweet &&
        row.retweeted_status.extended_tweet.extended_entities &&
        row.retweeted_status.extended_tweet.extended_entities.media
      ) {
        entities =
          row.retweeted_status.extended_tweet.extended_entities.media;
      }
      if (
        row.retweeted_status.extended_entities &&
          row.retweeted_status.extended_entities.media
      ) {
        entities =
          row.retweeted_status.extended_entities.media;
      }
    } else {
      // オーガニックツイートで140文字超えた場合の画像取得対応
      if (
        row.extended_tweet &&
        row.extended_tweet.extended_entities &&
        row.extended_tweet.extended_entities.media
      ) {
        entities = row.extended_tweet.extended_entities.media;
      }
      if (
        row.extended_entities && row.extended_entities.media
      ) {
        entities = row.extended_entities.media;
      }
    }

    let imgs = [];
    imgs = entities.map((entitie) =>
        <img key={entitie.media_url_https} className={classes.img} src={entitie.media_url_https} alt="ツイート画像" width="300" />
    );

    if (imgs) {
      return (
        <div className={classes.imgList}>
          {imgs}
        </div>
      );
    } else {
      return null;
    }
  };

  return (
    <List className={classes.root}>
      <ListItem alignItems="flex-start">
        {!isPrimaryHide && (
          <ListItemAvatar>
            <Avatar alt={row.user.name} src={row.user.profile_image_url_https} />
          </ListItemAvatar>
        )}
        <ListItemText
          primary={
            !isPrimaryHide ? (
              <React.Fragment>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.inline}
                  color="textPrimary"
                >
                  {row.user.name}
                </Typography>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.inline}
                  color="textPrimary"
                >
                  （{row.user.screen_name}）
                </Typography>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.inline}
                  color="textPrimary"
                >
                  <Link to={`/users/details?activeGroup=${activeGroup}&user=${row.user.screen_name}`}>
                    <PeopleIcon color="primary" />
                  </Link>
                </Typography>
                {order == "retweet" && (
                  <Typography
                    component="p"
                    variant="body2"
                    className={classes.rtCount}
                    color="textPrimary"
                  >
                    {retweetCount > 0 ? retweetCount + "件" : ""}
                  </Typography>
                )}
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.book}
                  color="textPrimary"
                >
                  {/* tweet が retweet の場合は retweet 元の id_str を充てる */}
                  { !row.retweeted_status &&
                    <Link to={`/retweets/monthly?activeGroup=${activeGroup}&id=${row.id_str}&dateTo=${toDate}&dateFrom=${fromDate}`}>
                      <MenuBookIcon color="primary" />
                    </Link>
                  }
                  { row.retweeted_status &&
                    <Link to={`/retweets/monthly?activeGroup=${activeGroup}&id=${row.retweeted_status.id_str}&dateTo=${toDate}&dateFrom=${fromDate}`}>
                      <MenuBookIcon color="primary" />
                    </Link>
                  }
                </Typography>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Typography
                  component="p"
                  variant="body2"
                  className={classes.isPrimaryHideBook}
                  color="textPrimary"
                >
                  {/* tweet が retweet の場合は retweet 元の id_str を充てる */}
                  { !row.retweeted_status &&
                    <Link to={`/retweets/monthly?activeGroup=${activeGroup}&id=${row.id_str}&dateTo=${toDate}&dateFrom=${fromDate}`}>
                      <MenuBookIcon color="primary" />
                    </Link>
                  }
                  { row.retweeted_status &&
                    <Link to={`/retweets/monthly?activeGroup=${activeGroup}&id=${row.retweeted_status.id_str}&dateTo=${toDate}&dateFrom=${fromDate}`}>
                      <MenuBookIcon color="primary" />
                    </Link>
                  }
                </Typography>
              </React.Fragment>
            )
          }
          secondary={
            <React.Fragment>
              <Typography
                component="p"
                variant="body2"
                color="textPrimary"
                className={classes.text}
              >
                {replaceTweetText(row)}
              </Typography>

              {!isHideImage && <MyImg row={row} />}
              <ul className={classes.footer}>
                <li>
                  {
                    <p className={classes.postDate}>
                      {dayjs(row.created_at).format("YYYY/MM/DD HH:mm:ss")}
                    </p>
                  }
                </li>
                <li>
                  <a
                    href={`https://twitter.com/${row.user.screen_name}/status/${row.id_str}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LaunchIcon />
                  </a>
                </li>
              </ul>
            </React.Fragment>
          }
        />
      </ListItem>
      <Divider variant="inset" component="li" />
    </List>
  );
}
